import { gql } from '@apollo/client/core';

export const CREATE_SCHOOL_GRADE = gql`
  mutation createSchoolGrade($createGradeInput: SchoolGradeInput!) {
    createSchoolGrade(createGradeInput: $createGradeInput) {
      id
      name
      grade
      minimum
      maximum
      point
      group
    }
  }
`;

export const UPDATE_SCHOOL_GRADE = gql`
  mutation updateSchoolGrade($id: ID!, $updateGradeInput: SchoolGradeInput) {
    updateSchoolGrade(id: $id, updateGradeInput: $updateGradeInput) {
      id
      name
      grade
      minimum
      maximum
      point
      group
    }
  }
`;

export const DELETE_SCHOOL_GRADE = gql`
  mutation deleteSchoolGrade($id: ID!) {
    deleteSchoolGrade(id: $id) {
      id
    }
  }
`;

export const UPDATE_SCHOOL_GRADE_GROUP = gql`
  mutation updateSchoolGradeGroup($id: ID!, $name: String!) {
    updateSchoolGradeGroup(id: $id, name: $name) {
      id
      name
      description
    }
  }
`;

export const DELETE_SCHOOL_GRADE_GROUP = gql`
  mutation deleteSchoolGradeGroup($id: ID!) {
    deleteSchoolGradeGroup(id: $id) {
      id
    }
  }
`;

export const CREATE_SCHOOL_GRADE_BULK = gql`
  mutation createSchoolGradeBulk($inputs: [CreateSchoolGradeBulkInput!]!) {
    createSchoolGradeBulk(inputs: $inputs) {
      id
      name
      grade
      minimum
      maximum
      point
      group
    }
  }
`;
